module.exports = class FieldValueCtrl
  constructor: ->
    'ngInject'
